module.exports = __webpack_public_path__ + "img/rio-aquidauana.eea32d3a.jpg";